import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { Loader, Tabs } from '@mantine/core'
import {
  IconPlaneArrival,
  IconPlaneDeparture,
  IconRotateClockwise,
  IconTemperatureSun,
} from "@tabler/icons-react";
import moment from 'moment'
import FlightMap from '../FlightTracking/FlightMap'
import FlightRouteCard from './FlightRouteCard'
import AltitudeGraph from './AltitudeGraph';
import base_url from '../../api/bootapi';
import * as Ably from 'ably';

 let ably = new Ably.Realtime({ key: "qlt41Q.2h6qug:R1FagOtYTS6H1DGFP3XBvSKezDqyG2gAnvX3o2X3Nis", recover: (_, cb) => {
    cb(true);
 },
 });
  
 let messagesSubscription ={}
const FlightStatsDetails = ({flightLiveDetails,indivisualFlight}) => {



 
   const [flightData, setFlightData] = useState([]);
  const [airports, setAirports] = useState([]);
  
   const [toAirport, setToAirport] = useState([]);
    const [fromAirport, setFromAirport] = useState([]);
  const [flightStatus, setFlightStatus] = useState(null);
   const [currentFlightPosition, setCurrentFlightPosition] = useState([]);
    const [heading, setHeading] = useState(0);
    const [departureCode, setDepartureCode] = useState(null);
  const [arrivalCode, setArrivalCode] = useState(null);
  
    const [requestData, setRequestData] = useState(null);
    const [upcomingDates, setUpcomingDates] = useState([]);
    const [activeTab, setActiveTab] = useState(null);
  
  const [flightDetails,setFlightDetails]=useState(flightLiveDetails)
  const [loading, setLoading] = useState(false);
  
  console.log(flightLiveDetails)
    useEffect(() => {
      if (airports.length > 0) {
        const toAirportIndex = airports.find(
          (airport) => airport.fs === arrivalCode
        );
  
        console.log("toAirportIndex", toAirportIndex);
        console.log("arrivalCode", arrivalCode);
  
        const fromAirportIndex = airports.find(
          (airport) => airport.fs === departureCode
        );
  
        if (toAirportIndex) {
          setToAirport(toAirportIndex);
        }
  
        if (fromAirportIndex) {
          setFromAirport(fromAirportIndex);
        }
  
        console.log("fromAirportIndex", fromAirportIndex);
        console.log("departureCode", departureCode);
      }
    }, [airports]);
  
  const [flightHeading, setFlightHeading] = useState(null);
  const [flightSpeed, setFlightSpeed] = useState(null);
  const [flightAltitude, setFlightAltitude] = useState(null);
  
    const handleViewMore = async(flightLiveDetails) => {
  

      console.log("Fligth Details ===== >",flightLiveDetails)
   
      if (flightLiveDetails.error) {

        return
      }
          setFlightData(flightLiveDetails?.appendix?.airports);
        const responseAirports = flightLiveDetails?.appendix?.airports;

        console.log("Airport List ====== > ",responseAirports)
        if (responseAirports && responseAirports.length > 0) {
          const mappedAirports = responseAirports.map((airport) => ({
            ...airport,
            lat: airport.latitude,
            lng: airport.longitude,
          }));
        console.log("Mapped Airport List ====== > ",mappedAirports)

          setAirports(mappedAirports);
        } else {
          setAirports([]);
        }
  
        // const flightStatus = response?.data?.flight_status?.flightStatuses[0];
        // console.log(flightStatus);
        // setFlightStatus("L");
  
        // setDepartureCode(
        //   flightLiveDetails?.flightTrack.departureAirportFsCode || null
        // );
        // setArrivalCode(
        //  flightLiveDetails?.flightTrack.arrivalAirportFsCode || null
        // );
  
        // console.log("Departure Code =======> ", flightLiveDetails?.flightTrack.departureAirportFsCode)
        // console.log("Arrival Code =========>", flightLiveDetails?.flightTrack.arrivalAirportFsCode)
        
      
       
        const currentFlightPosition =
          flightLiveDetails?.flightTrack?.positions;
      const heading = flightLiveDetails?.flightTrack?.heading?.toFixed(2) || 0;
      

      setFlightAltitude(currentFlightPosition[0]?.altitudeFt);
      setFlightSpeed(currentFlightPosition[0]?.speedMph);
        console.log("Heading =========> ",heading)
        console.log("Flight Position ==========>  ",currentFlightPosition)
        setHeading(heading);
  


        setCurrentFlightPosition(currentFlightPosition);
        setLoading(false);
    
     
    
    


  };
  

  
   const [backdropOpen,setBackdropOpen]=useState(false)
  const handleRefresh = () => {
      

     setBackdropOpen(true)
  
  
      axios.get(`${base_url.api1}/users/org_flight_stats_live_tracking?flight_id=${indivisualFlight?.flight_id}`)
        .then((response) => {
          const flight = response.data.Flight_Track;
        setBackdropOpen(false)
          if (flight) {
           setFlightDetails(flight)
          }
        
        })
        
        .catch((error) => {
          setBackdropOpen(false)
         
          console.error("Error fetching flight details:", error);
        });
      
      
  
  
    };

  useEffect(() => {

    
    
    
    if (flightDetails) {
      
      handleViewMore(flightDetails)
    }
  }, [flightDetails])




  useEffect(() => {
  if (indivisualFlight?.status !== "A") return;
  if (!indivisualFlight?.flight_id) return;

  let channelRef = null;

  const fetchChannel = async () => {
    try {
      const res = await axios.post(
        `${base_url.api1}/users/create_or_get_channel`,
        { flight_id: indivisualFlight.flight_id }
      );

      const { channel } = res.data;
      console.log("Channel from API:", channel);

      ably.connect();

      channelRef = ably.channels.get(channel);

      // unsubscribe old
      channelRef.unsubscribe();

      // subscribe new
      messagesSubscription[channel] = channelRef.subscribe((msg) => {
        setFlightDetails(msg.data);
      });

    } catch (err) {
      console.log("Error fetching channel:", err);
    }
  };

  fetchChannel();

  // 🔥 Cleanup when flight changes OR component unmounts
  return () => {
    try {
      if (channelRef) {
        console.log("Unsubscribing channel...");
        channelRef.unsubscribe();
      }

      console.log("Closing Ably connection...");
      ably.close();   // 🔥 CLOSE ABLY SOCKET

    } catch (err) {
      console.log("Cleanup error:", err);
    }
  };

}, [indivisualFlight?.flight_id, indivisualFlight?.status]);

  useEffect(() => {

     if (indivisualFlight?.status !== "A") return;  // ❗ Only when active flight
  if (!indivisualFlight?.flight_id) return;
    const pingChannel = async () => {
      try {
        const res = await axios.get(
          `${base_url.api1}/users/ping_channel?flight_id=${indivisualFlight?.flight_id}`
          
        );

        console.log(res)
      } catch (err) {
        console.log(err.message)
      }
    }
    
    const interval = setInterval(() => {
      
      pingChannel();
    }, 1000 * 60 * 7)
    

    return () => {
    clearInterval(interval);
  };
  },[indivisualFlight?.flight_id, indivisualFlight?.status])
  




  // useEffect(() => {
  //   if (refresh) {
  //      handleViewMore(flightDetails)
  //   }
  // },[refresh])



    const dateFormat = (dateString) => {
    if (!dateString) return "";

    // Keep exactly as given (up to minutes)
    const trimmed = dateString.slice(0, 16);

    const [datePart, timePart] = trimmed.split("T");
    const [year, month, day] = datePart.split("-");
    const [hour, minute] = timePart.split(":");

    // Only for weekday/month name — no effect on time
    const tempDate = new Date(`${year}-${month}-${day}`);
    const weekday = tempDate.toLocaleDateString("en-GB", { weekday: "long" });
    const monthName = tempDate.toLocaleDateString("en-GB", { month: "short" });

    return {
      date: `${weekday}, ${day} ${monthName} ${year}`,
      time: `${hour}:${minute}`,
    };
  };

   function getDelayStatus(scheduled, actual) {
      console.log(scheduled, actual);
      if (
        scheduled === null ||
        scheduled === undefined ||
        scheduled === "" ||
        actual === null ||
        actual === undefined ||
        actual === ""
      ) {
        return (
          <span style={{ fontSize: "15px", color: "green", fontWeight: "600" }}>
            {" "}
            On time
          </span>
        );
      }
  
      const diffMinutes = moment(actual).diff(moment(scheduled), "minutes");
  
      let value, unit;
      if (Math.abs(diffMinutes) >= 60) {
        value = (Math.abs(diffMinutes) / 60).toFixed(1); // hours
        unit = "hr";
      } else {
        value = Math.abs(diffMinutes); // minutes
        unit = "m";
      }
  
      if (diffMinutes > 0) {
        return (
          <span style={{ fontSize: "15px", color: "red", fontWeight: "600" }}>
            {" "}
            {value}
            {unit} Delay
          </span>
        );
      } else if (diffMinutes < 0) {
        return (
          <span style={{ fontSize: "15px", color: "green", fontWeight: "600" }}>
            {" "}
            {value}
            {unit} Early
          </span>
        );
      } else {
        return (
          <span style={{ fontSize: "15px", color: "green", fontWeight: "600" }}>
            {" "}
            On time
          </span>
        );
      }
    }
    function formatMinutesToHours(minutes) {
    if (minutes === null || minutes === undefined) return null;
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    return `${h}h ${m}m`;
  }
  function getFlightDuration(flightDurations, status) {
    if (!flightDurations || typeof flightDurations !== "object") return null;

    const { scheduledBlockMinutes, blockMinutes, airMinutes } = flightDurations;

    let minutes = null;

    if (status === "S" || status === "A") {
      // Scheduled or In Air
      minutes = scheduledBlockMinutes ?? airMinutes ?? null;
    } else if (status === "L") {
      // Landed
      minutes = blockMinutes ?? scheduledBlockMinutes ?? airMinutes ?? null;
    } else {
      // Fallback
      minutes = scheduledBlockMinutes ?? blockMinutes ?? airMinutes ?? null;
    }

    return formatMinutesToHours(minutes);
  }


   function getFlightStage(operationalTimes, status) {
    let stage = "Scheduled";
    let color = "#2B9950"; // default grey

    // Priority: use status if it's clear
    switch (status) {
      case "S":
        stage = "Scheduled";
        color = "#2B9950"; // grey
        break;
      case "A":
        stage = "Departed";
        color = "#DC3532"; // blue
        break;
      case "L":
        stage = "Arrived";
        color = "#28a745"; // green
        break;
      case "C":
        stage = "Cancelled";
        color = "#dc3545"; // red
        break;
      case "D":
        stage = "Diverted";
        color = "#ff9800"; // orange
        break;
      case "R":
        stage = "Redirected";
        color = "#ff9800"; // orange
        break;
      case "U":
        stage = "Unknown";
        color = "#6c757d"; // dark grey
        break;
      default:
        // If status isn't enough, check actual times
        if (
          operationalTimes?.actualRunwayArrival?.dateUtc ||
          operationalTimes?.actualGateArrival?.dateUtc
        ) {
          stage = "Arrived";
          color = "#28a745";
        } else if (
          operationalTimes?.actualRunwayDeparture?.dateUtc ||
          operationalTimes?.actualGateDeparture?.dateUtc
        ) {
          stage = "Departed";
          color = "#17a2b8"; // teal
        }
        break;
    }

    return (
      <span
        style={{
          padding: "4px 8px",
          borderRadius: "4px",
          backgroundColor: color,
          color: "#fff",
          fontWeight: "bold",
          fontSize: "0.9rem",
        }}
      >
        {stage}
      </span>
    );
  }


   function getPastTimeDiffReadable(utcDateString) {
      const target = moment.utc(utcDateString);
      const now = moment.utc();
  
      let diffMinutes = now.diff(target, "minutes");
  
      if (diffMinutes < 1) {
        return "Just now";
      }
  
      if (diffMinutes < 60) {
        return `${diffMinutes} minutes ago`;
      }
  
      let diffHours = now.diff(target, "hours");
      if (diffHours < 24) {
        return `${diffHours} hours ago`;
      }
  
      let diffDays = now.diff(target, "days");
      return `${diffDays} days ago`;
  }
  



  return (
    <div>


      
             
               
      
              
                  <div
                    className="flight-data-container"
                    style={{ marginTop: "40px", }}
                  >
                   
                  
            
          
          <FlightRouteCard flight={indivisualFlight} viewMore={false} />
           {
            currentFlightPosition && currentFlightPosition.length > 0 && <div className='altitude-wrapper'>

              <div  className='altitude-left'>
                <AltitudeGraph
                     positions={currentFlightPosition}
                />
                <div className='altitude-text'>
                  <span>Altitude</span>
                </div>
              </div>
 
              
            {
              indivisualFlight?.status === "A" &&  <div className='altitude-right'>

                <div className='altitude-heading'>

                  <span>
                    Heading
                  </span>
                  <span>
                   {heading}
                  </span>
                </div>

                 <div className='altitude-heading'>

                  <span>
                    Altitude
                  </span>
                  <span>
                    {flightAltitude} ft
                  </span>
                </div>

                 <div className='altitude-heading'>

                  <span>
                    Speed
                  </span>
                  <span>
                    {flightSpeed} mph
                  </span>
                </div>
                </div>
            }
             
              



            </div>

          }
      
                    <div className="flight-data-refresh-wrapper">
                      {currentFlightPosition.length > 0 ? (
                        <span className="last-updated">
                          Updated{" "}
                          {getPastTimeDiffReadable(currentFlightPosition[0]?.date)}{" "}
                        </span>
                      ) : (
                        <span></span>
                      )}
      
            {/* {currentFlightPosition.length > 0 && indivisualFlight?.status === "A" &&
              <span
                className="refresh-btn"
                onClick={() => handleRefresh()}
              >
              <IconRotateClockwise size={"14px"} className={backdropOpen ? 'rotate-btn' :""
                } /> {backdropOpen ? "Refreshing" :"Refresh"}
              </span>
            
            } */}
          </div>
          

          {
            currentFlightPosition && currentFlightPosition.length > 0 ?  <FlightMap
                      airports={airports}
                      currentFlightPosition={currentFlightPosition}
                      heading={heading}
          /> : <div className='altitude-wrapper' style={{padding:"80px 30px"}}>
              <span className='value' style={{textAlign:"center"}}>Flight live Preview Not Available</span>
              </div>
          }


                   
                  </div>
               
    </div>
  )
}

export default FlightStatsDetails